import { message,Select } from "antd";
import React, { useEffect, useState } from "react";
import { useCommonStore } from "@/store/useCommonStore";
const { Option } = Select;

const RoleSelect = (props) => {
    const { value, onChange, className } = props;
    const data = useCommonStore.use.rolelist();
    const handleChange = value => {
        if(onChange) onChange(value);
      };
    const options = data.map(d => {
        return <Option value={d.Id} key={d.Id}>{d.Name}</Option>}
    );
    return (<Select
        className={className}
        placeholder="请选择角色..."
        mode="multiple"
        value={value}
        onChange={handleChange}
    >
        {options}
    </Select>);
}

export default RoleSelect;